import React from 'react';

function LayersHeading({ text, style = null, className = '' }) {
  const identifier = text.toLowerCase().replaceAll(' ', '');

  return (
    <div
      id={`layersheading-${identifier}`}
      data-testid={`layersheading-${identifier}`}
      className={`layer-heading ${className}`}
      style={{ ...style }}
    >
      {text}
    </div>
  );
}

export default LayersHeading;
